/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { rollbackRecord } from '@linc-technologies/linced-common/utils/record-rollback';

export default class SubcategoryDialog extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  entity = null;

  category = null;

  @tracked
  label = '';

  @action
  setLabel(value) {
    this.label = value;
  }

  @tracked
  description = '';

  @action
  setDescription(value) {
    this.description = value;
  }

  isPLP = false;

  @tracked
  saveInProgress = false;

  typeLabel = 'Goal';

  // onClose is the action to be performed when closing the dialog.
  onClose() {}

  // onSave is the action to be performed after saving the subcategory.
  onSave() {}

  // getStates is an action that retrieves all states for goals in this
  // subcategory.
  getStates() {}

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    if (this.entity) {
      this.label = this.entity.label;
      this.description = this.entity.description;
    }
  }

  @action
  closeDialog() {
    this.onClose();
  }

  @action
  getStatesToDelete() {
    this.getStates(...arguments);
  }

  @action
  save() {
    this.saveInProgress = true;
    let subcategory = this.entity;

    if (isEmpty(subcategory)) {
      subcategory = this.store.createRecord('goals/subcategory', {
        schoolId: this.get('session.school'),
        subjectId: this.subject,
        isPLP: this.isPLP,
        categoryId: this.category,
        sequence: this.category.get('subcategories.length') + 1,
      });
    }

    subcategory.setProperties({
      label: this.label,
      description: this.description,
    });

    subcategory
      .save()
      .then(() => {
        this.toaster.success(
          `${this.typeLabel} subcategory "${subcategory.get('label')}" saved.`,
        );
        this.onClose();
      })
      .catch(() => {
        // Unload a new record and revert an edited one; the form keeps the input.
        rollbackRecord(subcategory);
        this.toaster.error('Error saving subcategory.');
      })
      .finally(() => {
        this.saveInProgress = false;
        this.onSave();
      });
  }
}
